module.exports = __webpack_public_path__ + "media/images/1_Primary_logo_on_transparent_256-2496086fde8ad1284db30979ccb432de.png";